export const LOCALE_PREFIX = 'scenes.Gnosus.components.Workspace.components.EntityContextMenu'

export const ENTITY_CONTEXT_MENU_ITEM = {
    ADD_FAVOURITE: 'addFavourite',
    REMOVE_FAVOURITE: 'removeFavourite',
    REPORT: 'report',
    LINKAGES: 'linkages',
    DISTRAINTS: 'distraints',
}
